import { render, staticRenderFns } from "./products.vue?vue&type=template&id=a7f393f6&"
import script from "./products.vue?vue&type=script&lang=js&"
export * from "./products.vue?vue&type=script&lang=js&"
import style0 from "./products.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/proservdemo25/public_html/wp-content/themes/chop-child/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7f393f6')) {
      api.createRecord('a7f393f6', component.options)
    } else {
      api.reload('a7f393f6', component.options)
    }
    module.hot.accept("./products.vue?vue&type=template&id=a7f393f6&", function () {
      api.rerender('a7f393f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/products.vue"
export default component.exports